export default __webpack_public_path__ + "static/marketing-desktop-a928470c4aa61cd22c74cba92d1ac677.jpg";